var exports = {
  "kL": "xf0b3b88a--0a986f--container",
  "$0": "xf0b3b88a--0a986f--title-wrapper",
  "IU": "xf0b3b88a--0a986f--action-list",
  "Sv": "xf0b3b88a--0a986f--rating-counters",
  "jx": "xf0b3b88a--0a986f--rating-summary",
  "xU": "xf0b3b88a--0a986f--rate-aside-info",
  "Bt": "xf0b3b88a--0a986f--rate-value",
  "q4": "xf0b3b88a--0a986f--invisible",
};

module.exports = exports;
